import { FILTERS, SHARED_FILTERS } from 'constants/search';

/**
 * The shared filters this search narrows every content type by: the reader operated the control
 * and it still holds a value. Undoing a filter therefore undoes its strictness, with no separate
 * release path. Order follows SHARED_FILTERS so the emitted value is deterministic.
 * @param  {Object} params
 * @param  {Object.<String, Array>} params.filterValues
 * @param  {Array.<String>} params.touchedFields
 * @return {Array.<String>}
 */
export const ownedFilterFields = ({ filterValues = {}, touchedFields = [] } = {}) =>
  SHARED_FILTERS.filter(
    field => touchedFields.includes(field) && (filterValues[field] || []).length > 0,
  );

/**
 * Whether the reader has operated the diet control on this search - counted even once its value is
 * empty, which is the one thing values cannot encode: unchecking the diet we applied leaves a URL
 * byte-identical to one that was never seeded.
 * @param  {Array.<String>} touchedFields
 * @return {Boolean}
 */
export const dietWasTouched = (touchedFields = []) => touchedFields.includes(FILTERS.DIET_TYPE);

/**
 * Reads the ownership marker off a request. Deriving the result from SHARED_FILTERS rather than
 * from the input both whitelists it - unvalidated client input must not steer the response cache -
 * and gives one canonical spelling per set, so the cache key cannot be split by order or repeats.
 * @param  {*} raw
 * @return {Array.<String>}
 */
export const parseOwnedFilters = raw => {
  const fields = (typeof raw === 'string' ? raw.split(',') : []).map(field => field.trim());
  return SHARED_FILTERS.filter(field => fields.includes(field));
};
